// src/App.jsx - WITH AUTH GUARD
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { TooltipProvider } from '@/components/ui/tooltip';
import AppShell from './components/layout/AppShell';

// Main pages
import Home from './pages/Home';
import Connectors from './pages/Connectors';
import NewConnectorWizard from './pages/NewConnectorWizard';
import ConnectorFields from "./pages/ConnectorFields";
import ConfigureConnector from "./pages/ConfigureConnector";
import Charts from './pages/Charts';
import ChartBuilderPage from './pages/builder/ChartBuilderPage';
import { newBuilderPath } from './pages/builder/legacyRoutes';
import ChartDetail from './pages/ChartDetail';
import DataExplorer from './pages/DataExplorer';
import ModelPage from './pages/model/ModelPage';
import DashboardsPage from './pages/dashboards/DashboardsPage';
import DashboardPage from './pages/dashboards/DashboardPage';
import Logs from './pages/Logs';
import Admin from './pages/Admin';


// Auth pages
import Login from './pages/Login';
import AcceptInvitation from './pages/AcceptInvitation';
import Settings from './pages/Settings';
import SuperAdmin from './pages/SuperAdmin';

/** /charts/new and /charts/new?id=ID, from links and bookmarks made before step 12. */
function LegacyBuilderRedirect() {
  const { search } = useLocation();
  return <Navigate to={newBuilderPath(search)} replace />;
}

// ==========================================
// PROTECTED ROUTE COMPONENT
// ==========================================
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('auth_token');

  console.log('Current path:', window.location.pathname);
  
  if (!token) {
    // No token - redirect to login
    return <Navigate to="/login" replace />;
  }
  
  console.log('Token found, rendering protected content');
  
  return children;
}


// ==========================================
// APP COMPONENT
// ==========================================
export default function App() {
  return (
    <TooltipProvider delayDuration={200}>
    <Router>
      <Routes>
        {/* Public Auth Route */}
        <Route path="/login" element={<Login />} />
        <Route path="/invitations/accept" element={<AcceptInvitation />} />

        {/* Protected App Routes (with AppShell) */}
        <Route path="/*" element={
          <ProtectedRoute>
            <AppShell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/connectors" element={<Connectors />} />
                <Route path="/connectors/new" element={<NewConnectorWizard />} />
                <Route path="/connectors/:id/fields" element={<ConnectorFields />} />
                <Route path="/connectors/:id/configure" element={<ConfigureConnector />} />
                <Route path="/charts" element={<Charts />} />
                {/* Phase 3 step 12: the previous builder's URL opens the new one (and ?id= that chart). */}
                <Route path="/charts/new" element={<LegacyBuilderRedirect />} />
                <Route path="/charts/build" element={<ChartBuilderPage />} />
                <Route path="/charts/:id" element={<ChartDetail />} />
                {/* Phase 4 step 14a-3: dashboards (saved charts on a grid; everyone reads, admins and analysts edit). */}
                <Route path="/dashboards" element={<DashboardsPage />} />
                <Route path="/dashboards/:id" element={<DashboardPage />} />
                <Route path="/explorer" element={<DataExplorer />} />
                {/* Phase 3 step 13b: how each dataset's fields are classified (read by all, changed by admins). */}
                <Route path="/model" element={<ModelPage />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/settings/*" element={<Settings />} />
                <Route path="/super-admin/*" element={<SuperAdmin />} />
              </Routes>
            </AppShell>
          </ProtectedRoute>
        } />
      </Routes>
    </Router>
    </TooltipProvider>
  );
}